"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnerStatusManagementSection = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var auth_mocks_1 = require("../../../Metrics/auth-mocks");
var demo_auth_context_1 = require("../../auth/demo-auth-context");
var DropDownWithSearch_1 = require("../DropDownWithSearch");
var NOT_ASSIGNED_OPTION = 'Not assigned';
var STATUS_OPTIONS = ['In progress', 'Ready'];
var normalizeElementId = function (rawId) {
    var value = rawId.trim().toLowerCase();
    var firstDot = value.indexOf('.');
    if (firstDot < 0) {
        return value;
    }
    var leftPart = value.slice(0, firstDot);
    var rightPart = value.slice(firstDot + 1);
    var leftLooksLikeCategory = leftPart.indexOf(':') < 0;
    return leftLooksLikeCategory ? rightPart : value;
};
var hasPermissionForElement = function (permissions, elementId) {
    if (!elementId) {
        return false;
    }
    var normalizedElementId = normalizeElementId(elementId);
    return permissions.some(function (permission) {
        var normalizedPermission = permission.trim().toLowerCase();
        var firstDot = normalizedPermission.indexOf('.');
        if (firstDot < 0) {
            return false;
        }
        var category = normalizedPermission.slice(0, firstDot);
        var scopeValue = normalizedPermission.slice(firstDot + 1);
        if (scopeValue === '*') {
            return normalizedElementId.indexOf(category + ":") === 0;
        }
        return normalizeElementId(normalizedPermission) === normalizedElementId;
    });
};
var shouldShowStatusForElement = function (elementId) {
    if (!elementId) {
        return false;
    }
    var normalizedElementId = normalizeElementId(elementId);
    return (normalizedElementId.indexOf('data:') === 0 ||
        normalizedElementId.indexOf('tech:') === 0);
};
exports.OwnerStatusManagementSection = function (_a) {
    var elementId = _a.elementId, owner = _a.owner, owners = _a.owners, role = _a.role, initialStatus = _a.initialStatus;
    var activeUser = demo_auth_context_1.useDemoAuth().activeUser;
    var effectiveRole = role !== null && role !== void 0 ? role : activeUser.role;
    var shouldShowOwnerStatusSection = effectiveRole === 'admin' || effectiveRole === 'owner' || effectiveRole === 'group-owner';
    if (!shouldShowOwnerStatusSection) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var currentUserHasElementPermission = hasPermissionForElement(activeUser.permissions, elementId);
    var canEditOwner = effectiveRole === 'admin' ||
        (effectiveRole === 'group-owner' && currentUserHasElementPermission);
    var canEditStatus = effectiveRole === 'admin' ||
        (effectiveRole === 'group-owner' && currentUserHasElementPermission) ||
        (effectiveRole === 'owner' && currentUserHasElementPermission);
    var shouldShowStatusField = shouldShowStatusForElement(elementId);
    var sectionTitle = shouldShowStatusField ? 'Owner and Status Management' : 'Owner Management';
    var ownerOptions = react_1.useMemo(function () { return __spreadArrays([
        { key: NOT_ASSIGNED_OPTION, text: NOT_ASSIGNED_OPTION }
    ], auth_mocks_1.mockUsers.map(function (user) { return ({ key: user.id, text: user.displayName }); })); }, []);
    var initialOwnerIds = react_1.useMemo(function () {
        if (elementId) {
            var ownersFromMocks = auth_mocks_1.getOwnersForMetricsProperty(elementId).map(function (user) { return user.id; });
            if (ownersFromMocks.length > 0) {
                return ownersFromMocks;
            }
            if (effectiveRole === 'owner' && currentUserHasElementPermission) {
                return [activeUser.id];
            }
        }
        var ownerNames = owners && owners.length > 0 ? owners : owner ? [owner] : [];
        if (ownerNames.length === 0) {
            return [NOT_ASSIGNED_OPTION];
        }
        var names = ownerNames
            .map(function (name) { return name.trim().toLowerCase(); })
            .filter(function (name) { return name.length > 0; });
        var mappedIds = auth_mocks_1.mockUsers
            .filter(function (user) { return names.indexOf(user.displayName.trim().toLowerCase()) >= 0; })
            .map(function (user) { return user.id; });
        return mappedIds.length > 0 ? mappedIds : [NOT_ASSIGNED_OPTION];
    }, [activeUser.id, currentUserHasElementPermission, effectiveRole, elementId, owner, owners]);
    var _b = react_1.useState(initialOwnerIds), selectedOwnerIds = _b[0], setSelectedOwnerIds = _b[1];
    var _c = react_1.useState(initialStatus || STATUS_OPTIONS[0]), selectedStatus = _c[0], setSelectedStatus = _c[1];
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section ws-entity-popup-section--owner", "data-section-id": "owner-status" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, sectionTitle),
        react_1.default.createElement("div", { className: "ws-entity-popup-section-body-columns" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "ws-entity-popup-field-label" }, "Owner"),
                react_1.default.createElement(DropDownWithSearch_1.DropDownWithSearch, { ariaLabel: "Owner", selectedKey: selectedOwnerIds, multiSelect: true, options: ownerOptions, disabled: !canEditOwner, onChange: function (_event, option) {
                        if (!option) {
                            return;
                        }
                        var ownerId = option.key;
                        setSelectedOwnerIds(function (current) {
                            if (ownerId === NOT_ASSIGNED_OPTION && option.selected) {
                                return [NOT_ASSIGNED_OPTION];
                            }
                            var withoutNotAssigned = current.filter(function (value) { return value !== NOT_ASSIGNED_OPTION; });
                            if (option.selected) {
                                return withoutNotAssigned.concat(ownerId);
                            }
                            var next = withoutNotAssigned.filter(function (value) { return value !== ownerId; });
                            return next.length > 0 ? next : [NOT_ASSIGNED_OPTION];
                        });
                    } })),
            shouldShowStatusField && (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "ws-entity-popup-field-label" }, "Status"),
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { ariaLabel: "Status", selectedKey: selectedStatus, options: STATUS_OPTIONS.map(function (status) { return ({ key: status, text: status }); }), disabled: !canEditStatus, onChange: function (_event, option) {
                        if (option) {
                            setSelectedStatus(option.key);
                        }
                    } }))))));
};
